import accountLists from './accountLists/accountLists.component';
import balances from './balances/balances.component';
import component from './menu.component';
import impersonationBar from './impersonationBar/impersonationBar.component';
import incidents from './incidents/incidents.component';
import maintenances from './maintenances/maintenances.component';
import notifications from './notifications/notifications.module';

export default angular.module('mpdx.menu', [
    accountLists,
    balances,
    component,
    impersonationBar,
    incidents,
    maintenances,
    notifications,
]).name;
